import { render, staticRenderFns } from "./ResetPhone.vue?vue&type=template&id=070e0232&scoped=true"
import script from "./ResetPhone.vue?vue&type=script&lang=js"
export * from "./ResetPhone.vue?vue&type=script&lang=js"
import style0 from "./ResetPhone.vue?vue&type=style&index=0&id=070e0232&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070e0232",
  null
  
)

export default component.exports